// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"74790ab4","732":"038aac79","977":"f47f4366"}[chunkId] + ".chunk.js";
};